import { Navigate } from "react-router-dom";

import ROUTES from "../../data/constants/routes";

export default function TeaserTemp() {
  return <Navigate to={ROUTES.default.path} replace />;
}
